export default "__VITE_ASSET__052e9273__"